import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class CustomerDashboardService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    

    getCustomerUpdatedDetails(customerId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `customerdashboard/history/${customerId}`).pipe(
            map((res: any) => res),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
      }
    
 

}
